<div class="modal-header" mat-dialog-title>
    <div class="modal-header-titles">
        <h2 class="modal-title">Naturezas de operação utilizam este emissor</h2>
        <span class="modal-subtitle">Reatribua as naturezas antes de {{ data.descricaoAcao }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" [disabled]="isSalvando" (click)="cancelar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <p>
        As naturezas abaixo estão configuradas com o emissor <strong>{{ data.nomeEmissor }}</strong>.
        Escolha o emissor que passará a atendê-las. A ação só será concluída depois da reatribuição.
    </p>

    <ul class="list-unstyled d-grid gap-2 mb-3">
        @for (natureza of data.naturezas; track natureza.idNaturezaOperacao) {
        <li class="d-flex align-items-center flex-wrap gap-2">
            <span>{{ natureza.nome }}</span>
            @if (natureza.cfopPadrao) {
            <span class="status-badge badge-cinza">{{ natureza.cfopPadrao | mask: '0.000' : { patterns: cfopMaskPatterns } }}</span>
            }
        </li>
        }
    </ul>

    <app-select-pesquisavel
        [control]="idEmissorDestinoControl"
        label="Atribuir as naturezas a"
        [offlineList]="emissoresElegiveis"
        idField="idEmissor"
        nameField="descricaoExibicao"
        [isOptional]="true"
        emptyOptionLabel="Nenhum - usar o emissor padrão"
        placeholder="Nenhum - usar o emissor padrão"
        [disabled]="isCarregandoEmissores || isSalvando"
        subscriptSizing="dynamic"
        [hint]="hintEmissorDestino">
    </app-select-pesquisavel>

    <app-alert-card class="d-block mt-3" type="warning">
        @if (isNenhumSelecionado) {
        Com a opção "Nenhum", as naturezas passam a usar o emissor padrão para NF-e. Isso pode mudar a
        série, a numeração e o ambiente das próximas notas dessas naturezas.
        } @else {
        As próximas notas dessas naturezas passarão a usar a série, a numeração e o ambiente do emissor escolhido.
        }
    </app-alert-card>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button class="btn-secondary" type="button" [disabled]="isSalvando" (click)="cancelar()">
        Cancelar
    </button>
    <button mat-flat-button class="btn-primary" type="button" [disabled]="isCarregandoEmissores || isSalvando"
        (click)="confirmar()">
        @if (isSalvando) {
        <mat-spinner [diameter]="20" class="mat-spinner-btn"></mat-spinner>
        } @else {
        Reatribuir e continuar
        }
    </button>
</mat-dialog-actions>
